export const HOTEL_LIST_VIEW_ONLY = 'hotelListViewOnly';
export const HOTEL_LIST_MAP_VIEW = 'hotelListMapView';
export const HOTEL_LIST_SIMPLE = 'hotelListSimple';



// WEBPACK FOOTER //
// ./src/constants/HotelMap.js